
import { Component, OnInit, EventEmitter, Input, ViewChild } from '@angular/core';
import { Aguas, CargosDetallesInput, EstadoCuentaInformacionInput, CargosDetalles, Convenios, AplicarConvenioInput, AuxJasper, ParametroJasper, CancelaConvenioInput, SolicitudDetalles, DetalleConvenio, CalculoParcialidadesConveniosTiie, CalculoParcialidadesConveniosTiieInput, ConveniosHist, ConveniosHistInput, CatTiie } from 'app/entidades/entidades';
import { MuestraMensaje } from 'app/shared/utilerias/notificaciones/notificaciones.component';
import { CargosDetallesComponent } from '../../componentes/cargos-detalles/cargos-detalles.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { InfoTramiteInput, CalculoParcialidadesConvenios, CalculoParcialidadesConveniosInput, ConveniosChild, BuscaConvenios, BuscaConveniosInput, CatTipoDocumentos,BuscaDetalleSolicitud, BuscaDetalleSolicitudInput,BuscaTramite, CatTipoUsos } from '../../entidades/entidades';
import { CalculoParcialidadesConveniosTiieService} from '../../servicios/calculo-parcialidades-convenios-tiie.service';
import { AplicarConvenioService } from 'app/servicios/aplicar-convenio.service';
import { JasperService } from 'app/servicios/jasper.service';
import { MenuItem } from 'primeng/api';
import { BuscaConveniosService } from '../../servicios/busca-convenios.service';
import { Key } from 'protractor';
import { EstadoCuentaInformacionComponent } from '../estado-cuenta-informacion/estado-cuenta-informacion.component';
import { CatTipoDocumentosService } from "../../servicios/cat-tipo-documentos.service";
import { CancelaConvenioService } from 'app/servicios/cancela-convenio.service';
import { Observable, empty } from "rxjs";
import { SolicitudDetallesGridComponent } from '../solicitud-detalles-grid/solicitud-detalles-grid.component';
import { AguaBuscaCuentasService } from '../../servicios/agua-busca-cuentas.service';
import { CatTipoUsosService } from '../../servicios/cat-tipo-usos.service';
import { debug } from 'console';

@Component({
  selector: 'app-convenios',
  templateUrl: './convenios.component.html',
  styleUrls: ['./convenios.component.css']
})
export class ConveniosComponent implements OnInit {

  public detallesImput$ = new EventEmitter<CargosDetalles>();
  idAguasProceso: number;
  public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();
  public estadoCuentaInformacionInput$ = new EventEmitter<EstadoCuentaInformacionInput>();
  muestraMensaje = new MuestraMensaje();
  public cargosDetallesInputLimpio: CargosDetallesInput;
  public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;
  public aplicaConvenios = new AplicarConvenioInput();
  public cancelaConvenioInput = new CancelaConvenioInput();
  conveniosForm: FormGroup;
  public conveniosChild = new ConveniosChild(); 
  public convenios$ = new EventEmitter<Convenios>();
  public calculoConvenios = new CalculoParcialidadesConveniosInput();
  public calculoParcialidadesConveniosTiieInput = new CalculoParcialidadesConveniosTiieInput();
  public resultadoCalculo: CalculoParcialidadesConveniosTiie[]=[];

  public buscaDetalleSolicitud$: Observable<BuscaDetalleSolicitud>;
  public buscaDetalleSolicitudInput$ = new EventEmitter<BuscaDetalleSolicitudInput>();

  buscaTramite: BuscaTramite;
  infoTramiteInputProceso:InfoTramiteInput;
  public infoTramiteInput$ = new EventEmitter<InfoTramiteInput>();


  cols: any[];
  private _jasperService: JasperService;
  public jasperInputExporta$ = new EventEmitter<AuxJasper>();
  public auxJasper: AuxJasper;
  itemsMenu: MenuItem[];
  id_aguJasper: any;
  id_conJasper: any;
  flag:boolean;
  porcentaje: number;
  catTipoDocumentos: CatTipoDocumentos[];
  catTipoDocumentosFrom: FormGroup;

  public buscaConvenios = new  BuscaConveniosInput();
  public catTiie = new CatTiie();
  public resultadoBuscaConvenios: BuscaConvenios []=[];
  public detalleConvenio = new  DetalleConvenio();
  public conveniosHist = new ConveniosHist();

  motivoCancelacion: string = "";
  mostrarDialogoCancelacion: boolean = false;
  
  muestra = false ;
  valor = true;
  public doc: any;
  
  //public docuemntoItems   = SelectItem[];
  documentoSeleccionado : any;
  total: number;
  primerpago: number;
  public id_usuario_: any;
  public error: string= 'NO';
  public num_solicitud = '';
  public tipoUsos: any;
  public progressBar = false;


  display: boolean = false;
  showDialog() {
      this.display = true;
  }

  imprime: boolean = false;
  showPdf(){
    this.imprime = true;
  }

  public cargos: CargosDetalles;
  @ViewChild(CargosDetallesComponent, { static: false }) childCargosDetalle;
  @ViewChild(SolicitudDetallesGridComponent , {static: false }) childSolicitudDetallesGrid;
  @ViewChild(EstadoCuentaInformacionComponent, { static: false }) childEstadoCuentaInformacion;


  constructor(private formBuilder: FormBuilder,
              private calculoParcialidadesConveniosTiieService: CalculoParcialidadesConveniosTiieService,
              private aplicarConvenioService: AplicarConvenioService,
              private cancelaConvenioService: CancelaConvenioService,
              private buscaConveniosService: BuscaConveniosService,
              private catTipoDocumentosService: CatTipoDocumentosService,
              private catTipoUsosService: CatTipoUsosService,
              ) {  this.id_usuario_ = JSON.parse(localStorage.getItem('currentUser'));}

  ngOnInit() {
    this.conveniosForm = this.formBuilder.group({
      monto: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cobroInicial: [undefined,  [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      fechaCobroInicial: [Date],
      fechaConvenio: [Date],
      observaciones: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      numConvenio: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      numPagos: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      foliodoc: [undefined],
      tasaInteres: [undefined],
      doc: [undefined],
      mensaje: [undefined],
      _anticipo: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      tipoUso: [undefined],
    });



    // ===============================================================
    //Opciones del menu
    // ===============================================================
    this.itemsMenu = [
    
      {
        label: "Aplicar",
        icon: "pi pi-save",
        command: (event) => {
          this.aplicaConvenio();
        },
      },
      {
        label: "Recalcular",
        icon: "pi pi-refresh",
        command: (event) => {
          this.aCalcularParcialidades();
        },
      },
    
    ];
    
    this.cargafechas();
    //this.calculoConvenios.idUsuarioRealizaConvenio = this.id_usuario_.id;
    this.aplicaConvenios.idUsuarioRealizaConvenio  = this.id_usuario_.id;

    this.getAllCatTipoDucumentos();
    this.getTasaInteres();

  }
  async getAllCatTipoDucumentos() {
    try {
      // const datoRetorno = await this.catTipoDocumentosService.getAll().toPromise();
      const datoRetorno = await this.catTipoDocumentosService.getByGrupo(1).toPromise();
            
      const datosLista = datoRetorno.map((datos) => {
        return { decripcion: datos.descripcion, value: datos.descripcion };
      });
   
      this.doc = [{ decripcion: 'Seleccione...', value: null }, ...datosLista];
  
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso Por getAllCatTipoDucumentos", this.catTipoDocumentos);
    }
  }
  async getTasaInteres() {
    try {
      // const datoRetorno = await this.catTipoDocumentosService.getAll().toPromise();
      const datoretorno = await this.buscaConveniosService
      .getTasaInteres()
      .toPromise();

      this.catTiie = new CatTiie(); 
      this.catTiie = datoretorno; 

      this.conveniosForm.patchValue({ tasaInteres: this.catTiie.tasa });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso Por getTasaInteres");
    }
  }
  async cargafechas()
  {
    var date = new Date(new Date());
    var dayActual = date.getDate().toString().padStart(2, '0');
    var monthIndexActual = (date.getMonth() + 1).toString().padStart(2, '0');
    var yearActual = date.getFullYear();
    var fecha_act = yearActual.toString() + "-" + monthIndexActual.toString() + "-" + dayActual.toString();

    this.conveniosForm.patchValue({
      fechaCobroInicial: fecha_act,
      fechaConvenio: fecha_act
    });


  }
  async childAguaBuscaServicios(BuscaTramite: BuscaTramite)
  {
    try {
      this.progressBar = true;

      this.buscaTramite = BuscaTramite;
      
      //Emite Para Info del Trámite
      this.infoTramiteInputProceso = null;
      this.infoTramiteInputProceso = new InfoTramiteInput();
      this.infoTramiteInputProceso.idSolicitud = BuscaTramite.id;
      this.infoTramiteInput$.emit(this.infoTramiteInputProceso);

      if (BuscaTramite.idEstatus === 4) {
        throw new Error('El trámite o servicio se encuentra cancelado.');
      }
      if (BuscaTramite.idEstatus === 2) {
        throw new Error('El trámite o servicio se encuentra pagado.');
      }
      
      let buscaDetalleSolicitudInput = new BuscaDetalleSolicitudInput();
      buscaDetalleSolicitudInput.id = BuscaTramite.id;
      this.buscaDetalleSolicitudInput$.emit(buscaDetalleSolicitudInput);
    
      //Busca en Convenios 
      let buscaConveniosInput = new BuscaConveniosInput();
      buscaConveniosInput.idSolicitud = buscaDetalleSolicitudInput.id;
      await this.buscarConvenios(buscaConveniosInput);


    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    }finally{
      this.progressBar = false;
    }
  }

  async childAguaBuscaCuentas(idAgua: number) {
    try {
      this.progressBar=true;
      this.limpiador();
      this.idAguasProceso = idAgua;
      if(idAgua == null ) return;

            
      //let medidoresBusquedas = new Medidores();

      if (!this.idAguasProceso) {
        this.estadoCuentaInformacionInput$.emit(null);
        this.cargosDetallesInput$.emit(null);
        console.log("Paaso por el limpiador")
        return;
      }
      //Carga Informacion Estado de Cuenta

      let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
      estadoCuentaInformacionInput.idAgua = idAgua;
      this.estadoCuentaInformacionInput$.emit(estadoCuentaInformacionInput);

      //Carga detalle adeudos
      let cargosDetallesInput = new CargosDetallesInput();
      cargosDetallesInput.idAgua = idAgua;
      cargosDetallesInput.idEstatus = 1;
      this.cargosDetallesInput$.emit(cargosDetallesInput);

      //Busca en Convenios 
      let buscaConveniosInput = new BuscaConveniosInput();
      buscaConveniosInput.idAgua = idAgua;
      await this.buscarConvenios(buscaConveniosInput);

      let conveniosHistInput = new ConveniosHistInput();
      conveniosHistInput.idAgua = idAgua;
      await this.buscarConveniosHist(conveniosHistInput);

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.progressBar=false;
      console.log("Paso por childAguaBuscaCuentas");
    }
  }


  async calculaConvenioServicios(){
    try {
        this.progressBar=true;
        this.total = this.childSolicitudDetallesGrid.serviciosConsultas.reduce((total, servicio) => total + servicio.monto, 0);

        this.primerpago = Number((this.total * 0.20).toFixed(2));

        this.calculoConvenios.idSolicitud = this.childSolicitudDetallesGrid.idSolicitud;
        this.calculoConvenios.acumulado = this.total;
        this.calculoConvenios.anticipo = this.primerpago;
        this.calculoConvenios.idAgua = null;

   
        await this.aCalcularParcialidades();

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    }finally {
      this.progressBar=false;
      console.log("Paso por calculaConvenioServicios");
    } 
  }

  async childCargosDetalles(cargoDetalle: CargosDetalles) {
    try {
     this.total = this.childCargosDetalle.total;
     //this.total = this.childCargosDetalle.cargosDetallesTable 

      const tieneCargosAdicionales = this.childCargosDetalle.cargosDetallesTable.some(
        (cargo: { idServicios: number | null }) => cargo.idServicios !== null && cargo.idServicios !== undefined
      );
      
      if (tieneCargosAdicionales) {
        this.muestraMensaje.warning(
          "No es posible generar un convenio, ya que existen otros cargos adicionales al consumo.", 
          "top", 
          "center"
        );
        return;
      } 
     
     this.primerpago = Number((this.total * 0.20).toFixed(2));
     this.calculoConvenios.idAgua = cargoDetalle.idAgua;
     this.calculoConvenios.acumulado =  this.total;
     this.calculoConvenios.anticipo = this.primerpago;
     this.calculoConvenios.idSolicitud = null;



      await this.aCalcularParcialidades();

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por childCargosDetalles");
    } 
  }
 
  // ====================================================
  // Metodos para obtener datos de CalculoParcialidadesConvenios
  // ====================================================
  async aCalcularParcialidades() {
    try {
      this.progressBar=true;
      this.calculoConvenios.anticipo = this.conveniosForm.value._anticipo;
      this.conveniosChild  = this.conveniosForm.value;
      if (this.primerpago == 0) return;
      if (this.calculoConvenios.anticipo === null) {this.calculoConvenios.anticipo  = this.calculoConvenios.acumulado * 0.20;}

      this.childSolicitudDetallesGrid;
      if(this.childEstadoCuentaInformacion?.estadoCuentaTable[0].bloqueoVigente != null || this.childEstadoCuentaInformacion?.estadoCuentaTable[0].estatus == "CANCELADO"){
        this.flag=true;
        this.limpiador();
        throw new Error ('No es posible realizar un convenio en este momento, ya que la cuenta tiene un bloqueo vigente.')
      }else{
        this.flag=false;
      } 

      if (this.conveniosChild.numPagos == null){
        this.muestraMensaje.warning("Por favor, ingrese el número de pagos", "top", "center");
        return;
      }        
      if (this.conveniosChild.numPagos > 24 || this.conveniosChild.numPagos <= 0) {
        throw new Error("El número de pagos debe estar en un rango de 1 a 24.");
      }
      
      this.resultadoCalculo.splice(0);

      this.calculoConvenios.noPagos = this.conveniosChild.numPagos;
      this.calculoConvenios.fechaPrimerPago = this.conveniosChild.fechaCobroInicial;
      
      this.calculoParcialidadesConveniosTiieInput.noPagos = this.conveniosChild.numPagos;
      this.calculoParcialidadesConveniosTiieInput.porcentaje = this.porcentaje;
      this.calculoParcialidadesConveniosTiieInput.saldo = this.total;
      this.calculoParcialidadesConveniosTiieInput.anticipo = this.calculoConvenios.anticipo;
      this.calculoParcialidadesConveniosTiieInput.fechaCobroInicial = this.conveniosChild.fechaCobroInicial;
      
      debugger;

      const datoretorno = await this.calculoParcialidadesConveniosTiieService
        .postOperaciones(this.calculoParcialidadesConveniosTiieInput)
        .toPromise();
    
      this.resultadoCalculo = datoretorno;
      if(datoretorno) {
          this.muestra = true;
          const numero = Object.keys(datoretorno);
          for(var index of numero) {
            this.aplicaConvenios.detalle[index] = datoretorno[index];
          }

          await this.conveniosForm.patchValue({
            cobroInicial:  this.aplicaConvenios.detalle[0].importePagar.toString(),//datoretorno[0].montoPagoMensual,
            monto:  this.aplicaConvenios.detalle[0].saldoInsoluto.toString()
          });

          this.aplicaConvenios.idAgua      = this.calculoConvenios.idAgua;
          this.aplicaConvenios.idSolicitud = this.calculoConvenios.idSolicitud;
          this.aplicaConvenios.acumulado   = this.calculoConvenios.acumulado;
          this.aplicaConvenios.noPagos     = this.conveniosChild.numPagos;
          this.aplicaConvenios.anticipo    = this.calculoConvenios.anticipo;
          this.aplicaConvenios.idTipoPeriodo = 1;
      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.progressBar=false;
      console.log("Paso por aCalcularParcialidades");
    }
  }
  // ====================================================
  // Metodos para obtener datos del servicio buscaConvenios
  // ====================================================
  async buscarConvenios(buscaConvenio : BuscaConveniosInput) {
    try {
      this.progressBar=true;
      this.resultadoBuscaConvenios.splice(0);
      const datoretorno = await this.buscaConveniosService
        .add(buscaConvenio)
        .toPromise();

        const j = Object.keys(datoretorno);
        //  const datoRetorno = await this.catTipoUsosService.getSingle(this.aguasProceso.idTipoUso).toPromise();
        //  this.tipoUsos = datoRetorno.descripcion;
        //  this.conveniosForm.patchValue({
        //    tipoUso: this.tipoUsos
        //  });
  
        if (datoretorno.toString() === 'P0001: Existe un convenio en proceso, falta realizar el primer pago del 20 porciento.') {
          this.error= 'NO';
          this.error = datoretorno.toString();
          this.valor = false;
          this.showDialog();
        } else {
          for(var index of j) {
            this.resultadoBuscaConvenios[index] = datoretorno[index];
          }
        }
        if(this.resultadoBuscaConvenios.length > 0 ) {

          this.id_conJasper = this.resultadoBuscaConvenios[0].idConvenio;
          this.valor = false;
          // ------------Formato Fechas, buscar otra forma!! ---------------------------------
          var date = new Date(this.resultadoBuscaConvenios[0].fechacobroinicial);
          var dayActual = date.getDate().toString().padStart(2, '0');
          var monthIndexActual = (date.getMonth() + 1).toString().padStart(2, '0');
          var yearActual = date.getFullYear();
          var fecha_ini = yearActual.toString() + "-" + monthIndexActual.toString() + "-" + dayActual.toString();
  
          var date = new Date(this.resultadoBuscaConvenios[0].fechaconvenio);
          var dayActual = date.getDate().toString().padStart(2, '0');
          var monthIndexActual = (date.getMonth() + 1).toString().padStart(2, '0');
          var yearActual = date.getFullYear();
          var fecha_Conv = yearActual.toString() + "-" + monthIndexActual.toString() + "-" + dayActual.toString();
          // ---------------------------------------------------------------------------------
    
          this.doc = [{decripcion:this.resultadoBuscaConvenios[0].documento, value:this.resultadoBuscaConvenios[0].documento}];

          this.conveniosForm.patchValue({
              monto: parseFloat(this.resultadoBuscaConvenios[0].montoRestante) - parseFloat(this.resultadoBuscaConvenios[0].cobroinicial),
              cobroInicial :      this.resultadoBuscaConvenios[0].cobroinicial,
              fechaCobroInicial : fecha_ini,
              fechaConvenio :     fecha_Conv,
              observaciones :     this.resultadoBuscaConvenios[0].observaciones,
              numConvenio :       this.resultadoBuscaConvenios[0].numConvenio,
              numPagos :          this.resultadoBuscaConvenios[0].numpagos,
              foliodoc :          this.resultadoBuscaConvenios[0].folioDelDocumento,
              mensaje:  'LA CUENTA TIENE UN CONVENIO VIGENTE GENERADO POR '  + this.resultadoBuscaConvenios[0].usuarioGenero ,
          });
          // Asignar tasaInteres si existe
          if (this.resultadoBuscaConvenios[0].tasaInteres) {
            this.conveniosForm.patchValue({
              tasaInteres: this.resultadoBuscaConvenios[0].tasaInteres,
            });
          }

          this.detalleConvenio = new DetalleConvenio(); 
          this.detalleConvenio = JSON.parse(this.resultadoBuscaConvenios[0].detalle);
 
        }else{
          this.id_conJasper = null;
          this.valor = true;
          this.doc = [];
          this.detalleConvenio = new DetalleConvenio();
          this.conveniosForm.reset(); // Limpia todo el formulario
          await this.cargafechas();
          await this.getAllCatTipoDucumentos();
          await this.getTasaInteres();
          // Opcional: establecer valores iniciales si se requieren campos obligatorios
          this.conveniosForm.patchValue({
            mensaje: 'No se encontró información para el convenio.',
          });
        }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.progressBar=false;
      console.log("Paso por buscarConvenios");
    }
  }
  async buscarConveniosHist(buscaConvenioHist : ConveniosHistInput) {
    try {
      this.progressBar=true;
      const datoretorno = await this.buscaConveniosService
        .getBuscaConvenioHist(buscaConvenioHist)
        .toPromise();

        this.conveniosHist = datoretorno; 

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.progressBar=false;
      console.log("Paso por buscarConveniosHist");
    }
  }
  async aplicaConvenio ()
    {
      try {
        this.progressBar=true;
        this.conveniosChild  = this.conveniosForm.value;

        this.aplicaConvenios.datosgenerales.splice(0);

        if(this.aplicaConvenios.acumulado == null || this.aplicaConvenios.acumulado == 0 )
          throw new Error('Deve seleccionar al menos un periodo para realizar el convenio');  

        if (this.conveniosChild.foliodoc == null || this.conveniosChild.doc == null) 
          throw new Error("Debe indicar el documento con el que se identifica así como su folio.");
        

        this.aplicaConvenios.datosgenerales.push(this.conveniosChild) ;
        this.conveniosChild.doc = this.documentoSeleccionado.value;

        const datoretorno = await this.aplicarConvenioService
          .add(this.aplicaConvenios)
          .toPromise();


          if(datoretorno){
          this.id_conJasper = datoretorno[0].id;
          this.num_solicitud = datoretorno[0].numConvenio;
        }
          
        await this.showDialog();
        await this.limpiador();
       
      } catch (e) {
        this.muestraMensaje.error(e.message, "top", "center");
      } finally {
        this.progressBar=false;
        console.log("Paso por aplicaConvenio");
      }
      
  }
  async imprimeconvenio(){
      try {
        if(this.error != 'NO') 
          throw new Error (this.error); 

        this.auxJasper = new AuxJasper();
        //this.auxJasper.JasperReport.nombreReporte = '008_Formato_convenio';
        this.auxJasper.JasperReport.nombreReporte = 'CartaCompromiso'
        this.auxJasper.JasperReport.tipo = 'pdf';
        // -- Parametros --
        const _id_convenio  = new ParametroJasper();
        _id_convenio.nombre = '_id_convenio';
        _id_convenio.valor  =  this.id_conJasper + '';

         //const _id_agua = new ParametroJasper();
         //_id_agua.nombre = '_id_agua';
         //_id_agua.valor = this.id_aguJasper + '';
        

        //const _id_usuario  = new ParametroJasper();
        //_id_usuario.nombre = '_id_usuario';
        //_id_usuario.valor  = this.id_usuario_.id +'';

        await this.auxJasper.ParametroJasper.push(_id_convenio);
        //await this.auxJasper.ParametroJasper.push(_id_usuario);
        //await this.auxJasper.ParametroJasper.push(_id_agua);
        await this.jasperInputExporta$.emit(this.auxJasper);
        await this.showPdf();

      } catch (e) {
        this.muestraMensaje.error(e.message, "top", "center");
      } finally {
        console.log("Paso por imprimeconvenio");
      }

  }
  async imprimeconvenioD(){
    try {
        if(this.error != 'NO')
          throw new Error (this.error); 

        this.auxJasper = new AuxJasper();
        //this.auxJasper.JasperReport.nombreReporte = '008_Formato_convenio';
        this.auxJasper.JasperReport.nombreReporte = 'ConveniodeDiferido'
        this.auxJasper.JasperReport.tipo = 'pdf';
        // -- Parametros --
        const _id_convenio  = new ParametroJasper();
        _id_convenio.nombre = '_id_convenio';
        _id_convenio.valor  =  this.id_conJasper + '';
        await this.auxJasper.ParametroJasper.push(_id_convenio);
        await this.jasperInputExporta$.emit(this.auxJasper);
        await this.showPdf();

      } catch (e) {
        this.muestraMensaje.error(e.message, "top", "center");
      } finally {
        console.log("Paso por imprimeconvenio");
      }
  }
  async cancelaconvenio(){
    try {
      
      if (!this.motivoCancelacion.trim()) {
        this.muestraMensaje.warning("Debe ingresar un motivo de cancelación.", "top", "center");
        return;
      }

      this.cancelaConvenioInput = new CancelaConvenioInput();
      this.cancelaConvenioInput.idConvenio = this.resultadoBuscaConvenios[0].idConvenio;
      this.cancelaConvenioInput.observaciones = this.motivoCancelacion;
      
      const datoretorno = await this.cancelaConvenioService
      .postOperaciones(this.cancelaConvenioInput)
      .toPromise();

  

      if (datoretorno != null) {
         this.muestraMensaje.notification(
          "Convenio cancelado con éxito",
          "top",
          "center"
        );
         this.limpiador();
       }
       
    } catch (e) {
      this.muestraMensaje.error(e.message, "top","center");
    }finally{
      this.motivoCancelacion = "";
      this.mostrarDialogoCancelacion = false; // Cerrar diálogo
      console.log("Paso por cancela convenio")
    }
  }
  async limpiador() {
      try {
        this.resultadoCalculo.splice(0);
        this.aplicaConvenios.detalle.splice(0);
        this.aplicaConvenios.datosgenerales.splice(0);
        this.resultadoBuscaConvenios.splice(0);
        this.conveniosForm.reset();
        this.cargosDetallesInput$.emit(null); 
        this.estadoCuentaInformacionInput$.emit(null);
        this.muestra = false;
        this.valor = true;
        this.cargafechas();
        this.getAllCatTipoDucumentos();
      }
       catch (e) {
        this.muestraMensaje.error(e.message, "top", "center");
      } finally {
        console.log("Paso por limpiador");
      }
      
  }
  getRowStyle(row) {
    if (row.data.pagado === 1) {
      return 'green-row';
    } else {
      return null;
    }
  }
  getColorForPaymentStatusC(convenio: any): string {
    if (convenio.estatus ===  'VIGENTE' ) {
      return '#94AD76';
    } else {
      return '#DCDCDA'; 
    }
  }
  getColorForPaymentStatus(detalle: any): string {
    const currentDate = new Date();
    const fechaPago = new Date(detalle.fecha_pago);
    if (detalle.pagado === 1) {
      return '#94AD76';
    } else if (fechaPago < currentDate) {
      return '#EF6767';
    } else if (fechaPago > currentDate) {
      return '#EDF296';
    } else {
      return ''; // No hay color especificado
    }
  }
}

